import { FC } from 'react'

import { QbrAttachments } from './components/qbrAttachments/QbrAttachments'
import { QbrExport } from './components/qbrExport/QbrExport'

import styles from './ExportAndAttachments.module.scss'

export const ExportAndAttachments: FC = () => {
  return (
    <div className={styles.root}>
      <div className={styles.exportContainer}>
        <QbrExport />
      </div>
      <div className={styles.divider} />
      <div className={styles.attachmentsContainer}>
        <div className={styles.attachmentsLabel}>List of attachments</div>
        <QbrAttachments />
      </div>
    </div>
  )
}
